import React from "react";
import logo from "../../assets/images/novaLogoMain.png";
import { useLanguage } from "../../context/LanguageContext";

const InfoPay: React.FC = () => {
  const {t} = useLanguage();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-t from-white to-primary-color gap-y-5">
      <div className="w-[300px] md:w-[400px] h-[100px] flex justify-center items-center rounded-xl px-4 shadow-xl -mt-10">
        {/* Logo */}
        <img
          src={logo}
          alt="Logo"
          className="mx-auto mb-6 object-contain w-full h-full"
        />
      </div>

      <div className="bg-white p-8 rounded-xl shadow-xl w-[90%] md:w-1/2 text-center">
        {/* Bilgilendirme İkonu */}
        <svg
          className="mx-auto mb-6 text-green-500 h-16 w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4v.01M5.227 4.227a9 9 0 1113.546 13.546 9 9 0 01-13.546-13.546z"
          ></path>
        </svg>
        <h2 className="text-3xl font-semibold text-gray-800 mb-2">
          {t('payInfo', "title")}
        </h2>
        <p className="text-gray-600 mb-4">
          {t('payInfo', "desc")}
        </p>

        {/* Anasayfaya dön butonu */}
        <a
          href="/"
          className="inline-block px-6 py-3 bg-primary-color text-white font-semibold rounded-lg hover:bg-teal-800 transition duration-300"
        >
          {t('payInfo', "button")}
        </a>
      </div>
    </div>
  );
};

export default InfoPay;
